export default __webpack_public_path__ + "media/images/rollbacked-1d4d717e.svg";